import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import Checkbox from '@/components/molecules/Formik/Checkbox';
import { PractitionerChooserDialogBody } from '@/components/organisms/DocumentCard/PractitionerChooserDialog';
import { useTranslation } from '@/src/i18n';

const ShareCheckbox = ({ form, field }) => {
  const { t } = useTranslation();
  // if initial state is false (unchecked), we will focus on change
  const shouldFocusOnChange = React.useRef<boolean>(!field.value);
  const areaToFocus = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!field.value) form.setFieldValue('cards', []);
    // value is true (checked) and we did not focus before, scroll to element
    if (field.value && shouldFocusOnChange.current) {
      areaToFocus?.current?.scrollIntoView({ behavior: 'smooth' });
    }
    shouldFocusOnChange.current = !field.value;
  }, [field.value]);

  return (
    <>
      <div ref={areaToFocus} />
      <Checkbox
        field={field}
        className={`shareCheckbox ${
          !form.values.profileId.length ? 'disabled' : ''
        }`}
        label={t('share_to_practitioner')}
        disabled={!form.values.profileId.length}
      />

      {field.value && (
        <Box sx={{ mt: 1 }}>
          <PractitionerChooserDialogBody
            profileId={form.values.profileId}
            documentId={form.values.documentId}
          />
        </Box>
      )}
    </>
  );
};
export default ShareCheckbox;
